import { render, staticRenderFns } from "./ArticlesTable.vue?vue&type=template&id=40cd2858&scoped=true&"
import script from "./ArticlesTable.vue?vue&type=script&lang=js&"
export * from "./ArticlesTable.vue?vue&type=script&lang=js&"
import style0 from "./ArticlesTable.vue?vue&type=style&index=0&id=40cd2858&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40cd2858",
  null
  
)

export default component.exports